import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

const createActions = storeName => {
    const types = getTypes(storeName);
    const setRegisteredUser = createAction(types.SET_REGISTERED_USER);
    const setRegistrationFormId = createAction(types.SET_REGISTRATION_FORM_ID);
    const setAgeVerification = createAction(types.SET_AGE_VERIFICATION);
    const resetAgeVerification = createAction(types.RESET_AGE_VERIFICATION);
    const removePasswordValidation = createAction(types.REMOVE_PASSWORD_VALIDATION);
    const checkPinCode = createAction(types.CHECK_PIN_CODE);
    const setPinCodeStatus = createAction(types.SET_PIN_CODE_STATUS);

    const setStep = createAction(types.SET_STEP);
    const setTemporaryDOBValidation = createAction(types.SET_TEMPORARY_DOB_VALIDATION);
    const setTemporaryGenderValidation = createAction(types.SET_TEMPORARY_GENDER_VALIDATION);
    const setIsPinCodeOrDOBValid = createAction(types.SET_IS_PIN_CODE_OR_DOB_VALID);

    const phoneVerificationDone = createAction(types.PHONE_VERIFICATION_DONE);
    const phoneDobReceived = createAction(types.PHONE_DOB_RECEIVED);
    const setIsLoyalty = createAction(types.SET_IS_LOYALTY);
    const showPincode = createAction(types.SHOW_PINCODE);
    return {
        ...dynaForms.getActions(storeName),
        setRegistrationFormId,
        setRegisteredUser,
        setAgeVerification,
        resetAgeVerification,
        removePasswordValidation,
        checkPinCode,
        setPinCodeStatus,
        setStep,
        setTemporaryDOBValidation,
        setTemporaryGenderValidation,
        setIsPinCodeOrDOBValid,
        phoneVerificationDone,
        phoneDobReceived,
        showPincode,
        setIsLoyalty,
    };
};

export default createActions;
